import { SAVED_RECIPES_KEY } from "./constants";

export const storeSavedRecipes = (savedRecipes) => {
  localStorage.setItem(SAVED_RECIPES_KEY, JSON.stringify(savedRecipes));
  localStorage.setItem(`${SAVED_RECIPES_KEY}_date`, new Date().toString())
}
export const getSavedRecipesFromLocalStorage = () => JSON.parse(localStorage.getItem(SAVED_RECIPES_KEY));
